import { getLink } from '../../../../utils/utils';

import cuarr from '../../../images/curved-arrow_sm.png';

import author from './author';

const content = {
  rus: (
    `

    <p class="mb-3 mt-3 text-center bold">Убитая Чайка</p>

    <p class="mb-3">
      Да, чайка убита. Дважды: в пьесе А. П. Чехова – и в Русском драматическом театре г. Одессы. 
      Правда, во втором случае – в этом виновна не Одесса, а горячо любимая Чеховым Москва, вернее, столичный режиссёр, 
      поставивший эту пьесу в Одессе.
    </p>
    
    <p class="mb-3">
      Он уже отметился у нас – в претенциозном спектакле, отмеченном дурным вкусом: «Сумерки богов». 
      Свою рецензию на него я назвала: «Промокашка в роли бога»: блатной надрыв вместо томной тонкости декаданса. 
      Но мальчик, видно, «нашёл себя», нашёл свой собственный «оригинальный стиль», как пишут нынче в газетах. 
      Правда, никакого «своего» там нет, - но штампы, да, есть; т.е. «стиль» узнаваем. 
      Ритуальное заматывание бинтами просто повторяется в обеих постановках; ну, набил руку, так чего же отказываться? 
      Рыночный принцип: то, что «пипл хавает», должно повторяться, пока не приестся, в самом прямом и переносном смысле. 
    </p>
    
    <p class="mb-3">
      Ещё одна узнаваемая примета стиля – «улёты», столь близкие духу молодых, как его воспринимает режиссёр. 
      Если в «Вертинском» постоянно, настойчиво подчёркивалась наркомания, то у Чехова – чуть попроще: пьянство. 
      Дамы у Чехова – все бухие… 
      Очень прикольно смотрится и оживляет сцены.
    </p>
    
    <p class="mb-3">
      Только жаль убитую «Чайку»! 
      Ведь Чехов писал её для последней сцены, где Нина Заречная говорит: «Я поняла, что главное – не слава, не шум сцены. 
      Главное – терпеть. Терпеть и делать своё дело. 
      Теперь я настоящая актриса» 
      Вся пьеса о том, как из наивной и восторженной девочки, через горе и испытания, рождается человек, служащий своемй делу, 
      нашедший дорогу и идущий по ней; нашедший и реализовавший себя. 
      Пьеса называется «Чайка», а не «Сын», потому что главное в ней – история становления <b>ч е л о в е к а</b>. 
      Нина нашла себя и работает; а Треплев погибает, ибо не нашёл себя, и в произведениях его «цели нет». 
      Две линии в пьесе: <img src=${cuarr} alt="arrow down" style="width: 25px;" /> и <img src=${cuarr} style="transform: rotateX(180deg);width: 25px;" alt="arrow up"/> : из силы – слабость и из слабости – сила.
    </p>
    
    <p class="mb-3">
      Для чего же режиссёр убил пьесу, показав Нину в последнем акте раздрызганной, опустившейся пьянчужкой? 
      В пьесе она несколько раз повторяет: «Лошади ждут»; на сцене ободранная шатающаяся замарашка пришла, очевидно, после нескольких дней «шатания по полям». 
      И шатается она так узнаваемо… ну как мы все с перепоя. 
      «Тепло на сердце от этой близости героини к нам»!  
    </p>
    
    <p class="mb-3">
      Но пьеса-то получает прямо противоположный смысл! 
      Не утверждение работы и пути к цели как спасения – а наоборот: «Все умерли!». 
      Нет выхода; работать, взрослеть, стремиться к чему-то – глупо, бессмысленно и бесполезно. 
      «Вселенская смазь». 
      Всё тонет в грязи. 
    </p>
    
    <p class="mb-3">
      Интересно, что в спектакле практически нет купюр. 
      Исключено только несколько фраз Треплева да ещё эти повторения Нины про лошадей, которые её ждут. 
      То есть, финал намеренно сделан таким, как он есть: безнадёжным и грязным. 
      Как же велика роль режиссёра, если он, практически не меняя текста пьесы, может сделать её по смыслу совершенно противоположной тому, что хотел сказать автор! 
    </p>
    
    <p class="mb-3">
      Две постановки Литвина в одесском Русском театре. 
      Неужели бог любит троицу??!
    </p>

    <p class="article-date mb-5"><span>24. 1. 2009 года</span></p>
   



    <p class="mb-3 mt-3 text-center bold">Хороший вкус</p>

    <p class="mb-3">
      Если в отзыве на постановку пьесы «Чайка» лейтмотивом стал дурной вкус режиссёра Литвина, то, 
      говоря об инсценизации романа Стендаля «Красное и чёрное», всё время хочется говорить о хорошем вкусе режиссёра. 
      Это такая редкость в наше время – хороший вкус! 
      И ни одной уступки дурному вкусу, ни одной фальшивой ноты во всём спектакле! 
      Всё на едином дыхании, всё в едином стиле: просто, благородно, элегантно, красиво! 
      Как всегда в Русском театре, замечательный актёрский ансамбль, где каждый на своём месте и каждый делает то, что надо; 
      но когда режиссёр «попадает в точку» и актёры вместе с ним творят стильный и законченный спектакль – это праздник! 
    </p>

    <p class="mb-3">
      Я пишу не рецензию, а отзыв; я не обязана выделять лучшие сцены, лучших исполнителей. 
      Но даже если бы я хотела, я не могла бы сделать этого: из плотной, 
      тугой ткани спектакля нельзя вырвать какие-то отдельные эпизоды (хотя, конечно, 
      поражают своей красотой и тонким вкусом любовные сцены – это в наше-то время!). 
      Но в общем, спектакль не хочется «разбирать по косточкам»; единственное и цельное впечатление, 
      которое от него остаётся – красоты и благородства. 
    </p>

    <p class="mb-3">
      Спасибо! 
    </p>
    
    <p class="mb-3">
      Режиссёр – заслуженный деятель искусств России Борис Ентин.
    </p>

    <p class="article-date mb-5"><span>24. 1. 2009 года</span></p>



   
    <p class="mb-3 mt-3 text-center bold">Русский Иван</p>

    <p class="mb-3">
      «Дядя Ваня» в Русском театре – опять пьяные дамы Литвина! 
      Почему он думает, что прекрасная половина русской интеллигенции вечно валилась с ног и иначе, чем спьяни, говорить не могла? 
      Весьма удивляет и уже, признаться, надоело видеть в его постановках одно и то же: водка, наркотики… 
      И специальное «забивание», затаптывание высоких мыслей: если уж надо их произносить со сцены, то так, чтобы им НЕ поверили, 
      чтобы их НЕ донести до зрителя! 
      А то, не дай бог, посмеются, - а что страшнее для современного режиссёра, чем показаться старомодным в глазах молодёжи! 
    </p>

    <p class="mb-3">
      Играют все средне: Скарге всегда подносит букеты своя компания девиц. 
      Но на самой последней сцене этого совсем невыразительного спектакля меня поразила мысль: а что, если это аллегория? 
      Дядя Ваня, который всю жизнь работал на другого, всеми уважаемого пустоцвета; 
      на того, чья ценность существует только в его собственных глазах и в глазах тех, 
      кого он охмурил и заставил верить в своё превосходство. 
      И вот русский Иван (дядя Ваня) губит свою жизнь ради призрака; раздутый вампир высасывает из него деньги, силы, жизнь… 
      Неужели не похоже на США и прочий мир, или просто на них и русских? 
    </p>

    <p class="mb-3">
      Нет ничего более несовместимого, чем Чехов и аллегория; но <b>п р а в д а</b> прорывается отовсюду, взрывая асфальт, 
      – и в бытовейшей комедии Чехов, сам того не осознавая, выражает главный конфликт, 
      которым болело тогдашнее русское общество (а сейчас что, не болеет?). 
    </p>

    <p class="mb-3">
      А утешает его и остаётся верна ему – Мудрость, София. 
    </p>

    <p class="article-date mb-5"><span>30 мая 2009 года</span></p>


    <p class="mb-3 mt-3 text-center bold">Труффальдино из Бергамо</p>

    <p class="mb-3">
      Им, оказывается, под силу и комедия – весёлая комедия положений, такая забытая и старомодная сейчас!
    </p>

    <p class="mb-3">
      Но как ярко и <b>р а д о с т н о</b> играют актёры; и как с такой же радостью принимает их зал! 
      Как мы соскучились, оказывается, по ТЕАТРУ, по яркой, выразительной ИГРЕ! 
      Зал заполнен молодёжью; они не ждали 30 лет такой постановки, они вообще никогда такого не видели, – но как им это <b>н у ж н о</b>! 
      Стихия весёлой, лёгкой, радостной игры – и никакой чернухи и порнухи! 
    </p>

    <p class="mb-3">
      Нормальным людям нужен нормальный театр; и смех, и мораль – всё нужно, ко всему голод! 
    </p>

    <p class="mb-3">
      Мы возвращаемся в нормальное состояние. 
    </p>
    
    `
  )
}

const itemName = {
  rus: `РУССКИЙ ТЕАТР образца 2000-ых годов.`
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;